import { render } from "./CatalogSection.vue?vue&type=template&id=3a400034"
import script from "./CatalogSection.vue?vue&type=script&lang=js"
export * from "./CatalogSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__